var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6Dots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dot-stack-svgrepo-com 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5391 17.6641C10.5391 18.458 9.89547 19.1016 9.10156 19.1016C8.30765 19.1016 7.66406 18.458 7.66406 17.6641C7.66406 16.8702 8.30765 16.2266 9.10156 16.2266C9.89547 16.2266 10.5391 16.8702 10.5391 17.6641Z",
    fill: "#001B4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5391 12.3928C10.5391 13.1867 9.89547 13.8303 9.10156 13.8303C8.30765 13.8303 7.66406 13.1867 7.66406 12.3928C7.66406 11.5989 8.30765 10.9553 9.10156 10.9553C9.89547 10.9553 10.5391 11.5989 10.5391 12.3928Z",
    fill: "#001B4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5391 7.12158C10.5391 7.91549 9.89547 8.55908 9.10156 8.55908C8.30765 8.55908 7.66406 7.91549 7.66406 7.12158C7.66406 6.32767 8.30765 5.68408 9.10156 5.68408C9.89547 5.68408 10.5391 6.32767 10.5391 7.12158Z",
    fill: "#001B4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.3359 17.6641C15.3359 18.458 14.6923 19.1016 13.8984 19.1016C13.1045 19.1016 12.4609 18.458 12.4609 17.6641C12.4609 16.8702 13.1045 16.2266 13.8984 16.2266C14.6923 16.2266 15.3359 16.8702 15.3359 17.6641Z",
    fill: "#001B4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.3359 12.3928C15.3359 13.1867 14.6923 13.8303 13.8984 13.8303C13.1045 13.8303 12.4609 13.1867 12.4609 12.3928C12.4609 11.5989 13.1045 10.9553 13.8984 10.9553C14.6923 10.9553 15.3359 11.5989 15.3359 12.3928Z",
    fill: "#001B4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.3359 7.12158C15.3359 7.91549 14.6923 8.55908 13.8984 8.55908C13.1045 8.55908 12.4609 7.91549 12.4609 7.12158C12.4609 6.32767 13.1045 5.68408 13.8984 5.68408C14.6923 5.68408 15.3359 6.32767 15.3359 7.12158Z",
    fill: "#001B4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6Dots);
export default __webpack_public_path__ + "static/media/6Dots.3285dbdf0cb870bb5ac046c4efd72553.svg";
export { ForwardRef as ReactComponent };